
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.28 15.42c-2.965-2.857-2.966-7.485-.004-10.338 2.962-2.853 7.767-2.852 10.732.004 2.966 2.857 2.966 7.485.005 10.338-2.962 2.852-7.767 2.852-10.732-.005zM3.116 3c-4.156 4.004-4.152 10.496.005 14.5 3.63 3.497 9.228 3.943 13.357 1.335l5.136 4.948a1.57 1.57 0 002.161 0 1.434 1.434 0 000-2.082l-5.004-4.82c3.549-4.027 3.347-10.073-.601-13.876C14.01-.999 7.272-1.003 3.115 3.001z"}})])
          )
        }
      }
    